var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Modal',{staticClass:"my-modal top p-b",attrs:{"mask-closable":false,"title":"权益详情","footer-hide":true,"width":"600"},model:{value:(_vm.visible),callback:function ($$v) {_vm.visible=$$v},expression:"visible"}},[_c('Table',{attrs:{"columns":_vm.columns,"data":_vm.list}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }